import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { PropertyObservable } from '@common/util/property-observable.decorator';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { Project } from '@portal-core/projects/models/project.model';
import { ProjectsService } from '@portal-core/projects/services/projects.service';
import { Destination } from '@portal-core/publications/models/destination.model';
import { Publication } from '@portal-core/publications/models/publication.model';
import { ConnectorService } from '@portal-core/publications/services/connector.service';
import { Observable, of, switchMap } from 'rxjs';

@Component({
  selector: 'mc-publication-overview',
  templateUrl: './publication-overview.component.html',
  styleUrls: ['./publication-overview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicationOverviewComponent implements OnInit {
  @Input() publication: Publication;

  @PropertyObservable('publication') publication$: Observable<Publication>;

  creatorLicenseUser$: Observable<LicenseUser>;
  project$: Observable<Project>;
  destination$: Observable<Destination>;

  constructor(private licenseUsersService: LicenseUsersService, private projectsService: ProjectsService, private connectorService: ConnectorService) { }

  ngOnInit() {
    // Create an observable of the publication's creator
    this.creatorLicenseUser$ = this.publication$.pipe(
      switchMap(publication => publication && publication.CreatedByLicenseUser
        ? this.licenseUsersService.getItemById$(publication.CreatedByLicenseUser.Id)
        : of(null)
      )
    );

    // Create an observable of the publication's project
    this.project$ = this.publication$.pipe(
      switchMap(publication => publication && typeof publication.ProjectId === 'number'
        ? this.projectsService.getItemById$(publication.ProjectId)
        : of(null)
      )
    );

    // Create an observable of the publication's destination file
    this.destination$ = this.publication$.pipe(
      switchMap(publication => publication && publication.DestinationFilePath && publication.Build
        ? this.connectorService.getDestinationWithConnector$(publication.ProjectId, publication.Build.CommitId, publication.DestinationFilePath, false)
        : of(null)
      )
    );
  }
}
